import { LayoutDashboard, ListChecks, Tag, Images, Star } from "lucide-react";

// Compact dashboard used as the floating hero accent.
export const MiniDashboard = () => {
  return (
    <div className="w-full">
      <div className="flex items-center gap-2 border-b border-white/10 px-3.5 py-2.5">
        <div className="grid h-6 w-6 place-items-center rounded-md bg-gradient-blue">
          <LayoutDashboard className="h-3.5 w-3.5 text-primary-foreground" />
        </div>
        <div className="text-[11px] font-semibold text-navy-foreground">Dashboard</div>
        <span className="ml-auto flex h-1.5 w-1.5 rounded-full bg-[hsl(150,55%,52%)]" />
      </div>
      <div className="grid grid-cols-3 gap-2 p-3">
        {[
          { icon: ListChecks, label: "Services", val: "12" },
          { icon: Tag, label: "Pricing", val: "$" },
          { icon: Images, label: "Photos", val: "48" },
        ].map(({ icon: Icon, label, val }) => (
          <div key={label} className="rounded-lg bg-white/5 p-2.5 ring-1 ring-white/10">
            <Icon className="h-3.5 w-3.5 text-techblue-glow" />
            <div className="mt-2 text-sm font-bold text-navy-foreground">{val}</div>
            <div className="text-[9px] text-navy-muted">{label}</div>
          </div>
        ))}
      </div>
      <div className="px-3 pb-3">
        <div className="rounded-lg bg-white/5 p-2.5 ring-1 ring-white/10">
          <div className="flex items-center justify-between">
            <div className="h-1.5 w-20 rounded bg-white/50" />
            <Star className="h-3 w-3 fill-techblue-glow text-techblue-glow" />
          </div>
          <div className="mt-2 h-1.5 w-full rounded bg-white/20" />
          <div className="mt-1.5 h-1.5 w-2/3 rounded bg-white/20" />
        </div>
      </div>
    </div>
  );
};
